module.exports = __webpack_public_path__ + "img/bg_teacher.4ac06c93.png";